var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32823)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#CD0124"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1169 4.07812C13.4837 4.07812 13.7812 4.38525 13.7812 4.76438C13.7812 5.1435 13.4837 5.45062 13.1169 5.45062L13.0759 5.45006L11.6449 8.93306C11.7264 9.04725 11.7748 9.18844 11.7748 9.34088C11.7748 9.68963 11.5234 9.97762 11.1977 10.0215L9.72225 13.6131C9.83194 13.7351 9.89887 13.8994 9.89887 14.0794C9.89887 14.4585 9.60131 14.7656 9.23456 14.7656C8.86781 14.7656 8.57025 14.4585 8.57025 14.0794C8.57025 13.8971 8.63831 13.7318 8.75025 13.6091L7.05881 10.0254L7.01944 10.0277C6.67575 10.0277 6.39281 9.75769 6.3585 9.41119L6.35513 9.34088C6.35513 9.16706 6.41813 9.00844 6.52106 8.88694L4.89938 5.45062L4.88363 5.45175C4.53994 5.45175 4.257 5.18175 4.22269 4.83525L4.21875 4.76438C4.21875 4.38525 4.51631 4.07812 4.88306 4.07812C5.16262 4.07812 5.40169 4.25644 5.49956 4.50844H12.5004C12.5983 4.25644 12.8379 4.07812 13.1169 4.07812ZM9.13613 8.09494L7.66969 9.19744C7.69263 9.30491 7.6898 9.41628 7.66145 9.52246C7.6331 9.62863 7.58002 9.72658 7.50656 9.80831L9.19969 13.3942L9.23456 13.3926C9.2475 13.3926 9.261 13.3926 9.27394 13.3937L10.7128 9.891C10.5942 9.79688 10.5091 9.66704 10.47 9.52073C10.431 9.37442 10.4402 9.21943 10.4963 9.07875L9.13613 8.09494ZM5.43375 5.41688L6.96319 8.65744L7.01944 8.65462C7.15838 8.65462 7.28662 8.6985 7.39294 8.77275L8.7075 7.785L5.43375 5.41688ZM12.4824 5.58337L9.55969 7.77713L10.8484 8.71031C10.9091 8.68331 10.9744 8.66531 11.0424 8.658L11.1105 8.65462C11.1471 8.65462 11.1825 8.65744 11.2174 8.66363L12.4824 5.58337ZM12.3902 5.02031H5.74875L9.13106 7.46719L12.3902 5.02031Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32823"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChz);
export default __webpack_public_path__ + "static/media/chz.a8fcfd93aa6e21e647202873366eec34.svg";
export { ForwardRef as ReactComponent };